import { useMemo } from 'react';
import { Column, TextButton } from 'seagull';
import { PlusCircleLine } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import LegalTermsDropdownOld from "../../../LegalTermsDropdownOld/LegalTermsDropdownOld";
import { legalTermsModel } from "../../../../models";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetLegalTermsTID = prefixTestId => getTestIds(prefixTestId);
export const LegalTerms = _ref => {
  let {
    businessAndAgreementLegalTerms,
    agreementLegalTerms,
    onAgreementLegalTermsChange,
    isReadOnly,
    onUpload,
    testid
  } = _ref;
  const {
    LegalTermsTID
  } = useMemo(() => GetLegalTermsTID(testid), [testid]);
  const onLegalTermsChange = (legalTerms, index) => {
    const updatedAgreementLegalTerms = [...agreementLegalTerms];
    updatedAgreementLegalTerms[index] = legalTermsModel.toDraftLegalTermsDocuments(legalTerms);
    onAgreementLegalTermsChange(updatedAgreementLegalTerms);
  };
  const onAddAdditionalTermsOfService = () => {
    onAgreementLegalTermsChange([...agreementLegalTerms, null]);
  };
  const isMaxLegalTermsReached = (agreementLegalTerms === null || agreementLegalTerms === void 0 ? void 0 : agreementLegalTerms.length) >= 4;
  return /*#__PURE__*/_jsxs(Column, {
    gap: 24,
    children: [agreementLegalTerms.map((legalTerm, index) => {
      var _legalTerm$legalTerms;
      return /*#__PURE__*/_jsx(LegalTermsDropdownOld, {
        onChange: updatedLegalTerm => {
          onLegalTermsChange(updatedLegalTerm, index);
        },
        label: "Terms & Conditions",
        selectedLegalTerms: legalTerm !== null && legalTerm !== void 0 && legalTerm.legalTermsId ? businessAndAgreementLegalTerms.find(_ref2 => {
          let {
            id
          } = _ref2;
          return id === (legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId);
        }) : undefined,
        legalTerms: businessAndAgreementLegalTerms,
        showViewTosButton: true,
        isReadOnly: isReadOnly,
        onUpload: onUpload,
        onChangeOld: () => {},
        "data-testid": LegalTermsTID.LegalTermDropdown(index)
      }, (_legalTerm$legalTerms = legalTerm === null || legalTerm === void 0 ? void 0 : legalTerm.legalTermsId) !== null && _legalTerm$legalTerms !== void 0 ? _legalTerm$legalTerms : index);
    }), !isMaxLegalTermsReached && /*#__PURE__*/_jsx(TextButton, {
      "data-testid": LegalTermsTID.AddAdditionalTermsOfService(),
      onClick: onAddAdditionalTermsOfService,
      underline: "none",
      prefixIcon: /*#__PURE__*/_jsx(PlusCircleLine, {}),
      children: "Add additional Terms of Service"
    })]
  });
};